module.exports = __webpack_public_path__ + "img/hyl_p3.99c88b15.png";